import React from 'react';
import styled from 'styled-components';
import Navigation from '../components/layout/Navigation';
import PhotoGallery from '../components/sections/PhotoGallery';

const Photobook: React.FC = () => {
  return (
    <PhotobookContainer>
      <Navigation />
      <PhotoGallery />
    </PhotobookContainer>
  );
};

const PhotobookContainer = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
`;

export default Photobook; 